import { formatRelationshipLabel } from '../constants/relationshipTypes';

export interface GuardianDisplayInput {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_no?: string | null;
  display_name?: string | null;
  primary_relationship_type?: string | null;
  primary_child_first_name?: string | null;
  primary_child_last_name?: string | null;
}

export interface GuardianDisplayContext {
  relationshipType?: string | null;
  childFirstName?: string | null;
  childLastName?: string | null;
}

function trim(value?: string | null): string {
  return (value ?? '').trim();
}

function storedName(guardian: GuardianDisplayInput): string {
  return `${trim(guardian.first_name)} ${trim(guardian.last_name)}`.trim();
}

function childFullName(childFirstName?: string | null, childLastName?: string | null): string {
  return `${trim(childFirstName)} ${trim(childLastName)}`.trim();
}

export function formatGuardianDisplayName(
  guardian: GuardianDisplayInput,
  context: GuardianDisplayContext = {},
): string {
  if (trim(guardian.display_name)) {
    return trim(guardian.display_name);
  }

  const direct = storedName(guardian);
  if (direct) {
    return direct;
  }

  const relKey = trim(context.relationshipType ?? guardian.primary_relationship_type).toLowerCase() || null;
  const childFirst = trim(context.childFirstName ?? guardian.primary_child_first_name) || null;
  const childLast = trim(context.childLastName ?? guardian.primary_child_last_name) || null;
  const childFull = childFullName(childFirst, childLast);

  if (childLast || childFirst) {
    const surname = childLast || childFirst || '';
    if (relKey === 'mother' || relKey === 'stepmother') {
      return `Mrs ${surname}`;
    }
    if (relKey === 'father' || relKey === 'stepfather') {
      return `Mr ${surname}`;
    }
    if (relKey === 'grandparent') {
      return childFull ? `Grandparent of ${childFull}` : 'Grandparent';
    }
    if (relKey === 'parent' || relKey === 'guardian') {
      return `${surname} Guardian`;
    }
    const relLabel = formatRelationshipLabel(context.relationshipType ?? guardian.primary_relationship_type);
    if (relLabel && childFull) {
      return `${relLabel} of ${childFull}`;
    }
    if (relLabel) {
      return relLabel;
    }
  }

  const phone = trim(guardian.phone_no);
  if (phone) {
    return `Guardian (${phone})`;
  }
  const email = trim(guardian.email);
  if (email) {
    return `Guardian (${email})`;
  }
  return 'Guardian';
}

export function resolveGuardianListName(guardian: GuardianDisplayInput): string {
  return formatGuardianDisplayName(guardian).trim() || '-';
}
